import { useNavigate } from 'react-router-dom';
import { Card } from '../../../layout/Card.jsx';
import { Icon } from '../../../layout/Icon.jsx';
import { Pill } from '../../../layout/Pill.jsx';
import { useLowStockReport } from '../hooks/useStock.js';
import { useAuth } from '../../../shared/useAuth.js';

export function LowStockPanel() {
  const navigate = useNavigate();
  const hasPermission = useAuth((s) => s.hasPermission);
  const canPurchase = hasPermission('inventory.purchase.create');
  const { data, isLoading, error } = useLowStockReport();

  const items = data?.items || [];

  if (error) {
    return <Card><div className="text-red text-center py-4">تعذّر تحميل المخزون المنخفض</div></Card>;
  }
  if (isLoading) {
    return <Card><div className="text-ink-3 text-center py-8">جاري التحميل...</div></Card>;
  }

  return (
    <Card>
      <div className="card-h border-b-0 -mx-[18px] -mt-[16px] mb-3">
        <div className="flex-1">
          <h3 className="text-[14.5px] font-bold">مخزون منخفض</h3>
          <div className="text-xs text-ink-3 mt-0.5">
            {items.length} منتج بحاجة إلى إعادة طلب
          </div>
        </div>
      </div>
      {items.length === 0 ? (
        <div className="text-center py-10 text-ink-3 flex flex-col items-center gap-2">
          <Icon name="check" size={36} color="#22C55E" />
          <div className="font-bold text-[14px]">جميع المنتجات بكميات جيدة</div>
        </div>
      ) : (
        <div className="space-y-2">
          {items.map((p) => {
            const cur = Number(p.current ?? 0);
            const min = Number(p.minStock ?? 0);
            return (
              <div
                key={p.productId}
                className="flex items-center gap-3 p-3 rounded-[10px] border border-line bg-white hover:bg-paper-2"
              >
                <div className="flex-1 min-w-0">
                  <div className="font-bold truncate">{p.name}</div>
                  <div className="text-[11.5px] text-ink-3">
                    <span style={{ fontFamily: 'monospace' }}>{p.sku}</span>
                    {p.warehouse ? <> • {p.warehouse}</> : null}
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="text-center">
                    <div className="text-[10.5px] text-ink-3">المخزون</div>
                    <div className={cur === 0 ? 'font-bold text-red text-[16px]' : 'font-bold text-[16px]'}>
                      {cur}
                    </div>
                  </div>
                  <div className="text-center">
                    <div className="text-[10.5px] text-ink-3">الحد الأدنى</div>
                    <div className="text-ink-2 text-[14px]">{min}</div>
                  </div>
                  <Pill variant={cur === 0 ? 'danger' : 'warning'}>
                    {cur === 0 ? 'نفذ' : 'منخفض'}
                  </Pill>
                  {canPurchase ? (
                    <button
                      type="button"
                      className="btn btn-primary"
                      style={{ padding: '6px 10px', fontSize: 12 }}
                      onClick={() => navigate(`/purchase/new?productId=${p.productId}`)}
                    >
                      <Icon name="plus" size={13} /> فاتورة شراء
                    </button>
                  ) : null}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </Card>
  );
}
